__turbopack_context__.v({
  "footer": "Footer-module__7vZ9Tq__footer",
  "footerBottom": "Footer-module__7vZ9Tq__footerBottom",
  "footerBottomLinks": "Footer-module__7vZ9Tq__footerBottomLinks",
  "footerContainer": "Footer-module__7vZ9Tq__footerContainer",
  "footerCopy": "Footer-module__7vZ9Tq__footerCopy",
  "footerLeft": "Footer-module__7vZ9Tq__footerLeft",
  "footerLogo": "Footer-module__7vZ9Tq__footerLogo",
  "footerMiddle": "Footer-module__7vZ9Tq__footerMiddle",
  "footerRight": "Footer-module__7vZ9Tq__footerRight",
  "footerTagline": "Footer-module__7vZ9Tq__footerTagline",
});
